export default "__VITE_ASSET__DR6VOYAn__"